<template>
  <div class="schedule-page">
    <NavHeaderBar :showSearch="false" navBarTitle="Schedule" />

    <!-- Filter Bar -->
    <van-sticky :offset-top="46">
      <div class="filter-bar">
        <!-- Type Filter -->
        <div class="filter-item" :class="{ active: filter.scheduleType !== '' }" @click="openFilterPopup('type')">
          <span>{{ $t('shared.filter.type') }}</span>
          <van-icon name="play" class="filter-arrow" />
        </div>

        <!-- State Filter -->
        <div class="filter-item" :class="{ active: filter.state !== '' }" @click="openFilterPopup('state')">
          <span>{{ $t('shared.filter.state') }}</span>
          <van-icon name="play" class="filter-arrow" />
        </div>

        <!-- Date Filter Display -->
        <div class="filter-item date-item" :class="{ active: filter.startTime && filter.endTime }" @click="openFilterPopup('time')">
          <van-icon name="notes-o" class="calendar-icon" />
          <span class="date-text">{{ dateRangeText }}</span>
        </div>
      </div>
    </van-sticky>

    <!-- List -->
    <div v-if="scheduleList.length > 0" class="schedule-list">
      <div v-for="(item, index) in scheduleList" :key="index" class="schedule-card" @click="toPath(item)">
        <div class="card-top">
          <span class="time-text">{{ item.newScheduleTime }}</span>
          <!-- <span class="type-tag">{{ item.scheduleType === 1 ? 'Pop up' : item.scheduleType === 2 ? `${globalData.brandName} day` : item.scheduleType === 3 ? `Visit` : '' }}</span> -->
          <span class="type-tag">{{ item.scheduleType === 1 ? $t('form.popUp') : item.scheduleType === 2 ? $t('form.brandDay') : item.scheduleType === 3 ? $t('shared.visit') : '' }}</span>
        </div>
        <div class="card-bottom" v-for="(stepItem, stepIndex) in item.detailList" :key="stepIndex">
          <img v-if="stepItem.targetType === 1" src="@/assets/images/sd.png" class="store-icon" />
          <img v-else src="@/assets/images/store.png" class="store-icon" />
          <span class="store-name">{{ stepItem.targetName }}</span>
          <img src="@/assets/images/daohan1.png" class="nav-icon" @click.stop="navigate(item)" />
        </div>
        <div v-if="item.detailListTotal >= 4">
          {{ $t('form.total') }}：<span style="color: #307bff;">{{ item.customerCount }} {{ $t('shared.stores') }}, {{ item.sdCount }} {{ $t('shared.distributors') }}</span>
        </div>
      </div>
    </div>
    <van-empty v-else :description="$t('tips.noData')" />

    <!-- Type Popup -->
    <van-popup v-model="showTypePopup" position="bottom" round safe-area-inset-bottom>
      <div class="filter-popup-content">
        <div class="filter-title">{{ $t('shared.filter.filter') }}</div>
        <div class="filter-options">
          <div v-for="opt in typeOptions" :key="opt.value" class="filter-tag" :class="{ active: tempType === opt.value }" @click="tempType = opt.value">
            {{ opt.label }}
          </div>
        </div>
        <div class="filter-actions">
          <van-button block class="reset-btn" @click="tempType = ''">{{ $t('button.reset') }}</van-button>
          <van-button block type="info" class="confirm-btn" @click="confirmFilter('type')">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- State Popup -->
    <van-popup v-model="showStatePopup" position="bottom" round safe-area-inset-bottom>
      <div class="filter-popup-content">
        <div class="filter-title">{{ $t('shared.filter.filter') }}</div>
        <div class="filter-options">
          <div v-for="opt in stateOptions" :key="opt.value" class="filter-tag" :class="{ active: tempState === opt.value }" @click="tempState = opt.value">
            {{ opt.label }}
          </div>
        </div>
        <div class="filter-actions">
          <van-button block class="reset-btn" @click="tempState = ''">{{ $t('button.reset') }}</van-button>
          <van-button block type="info" class="confirm-btn" @click="confirmFilter('state')">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- Date Popup -->
    <van-popup v-model="showDatePopup" position="bottom" round safe-area-inset-bottom>
      <div class="filter-popup-content">
        <div class="filter-title">{{ $t('shared.filter.timeFilter') }}</div>
        <div class="time-selector">
          <div class="time-input" @click="showStartDatePicker = true">
            <span v-if="tempStartTime">{{ tempStartTime }}</span>
            <span v-else class="placeholder">{{ $t('shared.filter.startDate') }}</span>
          </div>
          <span class="separator">~</span>
          <div class="time-input" @click="showEndDatePicker = true">
            <span v-if="tempEndTime">{{ tempEndTime }}</span>
            <span v-else class="placeholder">{{ $t('shared.filter.endDate') }}</span>
          </div>
        </div>
        <div class="filter-actions">
          <van-button block class="reset-btn" @click="resetDate">{{ $t('button.reset') }}</van-button>
          <van-button block type="info" class="confirm-btn" @click="confirmFilter('time')">{{ $t('button.confirm') }}</van-button>
        </div>
      </div>
    </van-popup>

    <!-- Date Pickers -->
    <van-popup v-model="showStartDatePicker" position="bottom">
      <van-datetime-picker v-model="currentPickerDateStart" type="date" :title="$t('shared.filter.selectStartDate')" @confirm="onConfirmStartDate" @cancel="showStartDatePicker = false" />
    </van-popup>
    <van-popup v-model="showEndDatePicker" position="bottom">
      <van-datetime-picker v-model="currentPickerDateEnd" type="date" :title="$t('shared.filter.selectEndDate')" @confirm="onConfirmEndDate" @cancel="showEndDatePicker = false" />
    </van-popup>

  </div>
</template>

<script>
import NavHeaderBar from '@/components/NavHeaderBar'
import { arsScheduleListPageApi } from '@/api/home'
import moment from 'moment'
import { Toast } from 'vant'
import { formatScheduleTime } from '@/utils/date'
import { mapState, mapMutations } from 'vuex'

export default {
  name: 'Schedule',
  components: {
    NavHeaderBar
  },
  data () {
    return {
      // List Data
      scheduleList: [],

      // Filter State
      filter: {
        scheduleType: '', // 1: pop-up, 2: nextday
        state: '', // 0: 有效, 1: 无效
        startTime: '',
        endTime: ''
      },

      // Popup Controls
      showTypePopup: false,
      showStatePopup: false,
      showDatePopup: false,
      showStartDatePicker: false,
      showEndDatePicker: false,

      // Temp States for Popups
      tempType: '',
      tempState: '',
      tempStartTime: '',
      tempEndTime: '',

      currentPickerDateStart: new Date(),
      currentPickerDateEnd: new Date(),

      // Options
      typeOptions: [
        { label: this.$t('form.popUp'), value: 1 },
        { label: this.$t('form.brandDay'), value: 2 },
        // { label: 'Next day', value: 2 }
        { label: this.$t('shared.visit'), value: 3 }
      ],
      stateOptions: [
        { label: this.$t('shared.filter.effective'), value: 0 }, // 对应“有效”
        { label: this.$t('form.invalid'), value: 1 } // 对应“无效”
      ]
    }
  },
  computed: {
    ...mapState({
      globalData: 'globalData'
    }),
    dateRangeText () {
      if (this.filter.startTime && this.filter.endTime) {
        return `${this.filter.startTime}~${this.filter.endTime}`
      }
      return this.$t('shared.filter.selectDate')
    }
  },
  activated () {
    this.initDefaultDate()
    this.onLoad()
  },
  methods: {
    ...mapMutations('event', ['SET_EVENTINFO']),
    toPath (params) {
      if (params.scheduleType === 3) {
        this.$router.push(`/visitPlan/detail?planId=${params.sourceId}`)
      } else {
        this.SET_EVENTINFO({ eventId: params.sourceId, schedule: '' })
        this.$router.push(`/eventDetail?eventId=${params.sourceId}&pageType=`)
      }
    },
    initDefaultDate () {
      const today = moment()
      const endDay = moment().add(6, 'days') // Include today: +6 days

      this.filter.startTime = today.format('YYYY/MM/DD')
      this.filter.endTime = endDay.format('YYYY/MM/DD')

      // Sync temp
      this.tempStartTime = this.filter.startTime
      this.tempEndTime = this.filter.endTime
    },

    // --- Popup Handlers ---
    openFilterPopup (operType) {
      if (operType === 'type') {
        this.tempType = this.filter.scheduleType
        this.showTypePopup = true
      } else if (operType === 'state') {
        this.tempState = this.filter.state
        this.showStatePopup = true
      } else if (operType === 'time') {
        this.tempStartTime = this.filter.startTime
        this.tempEndTime = this.filter.endTime
        this.showDatePopup = true
      }
    },
    confirmFilter (operType) {
      if (operType === 'type') {
        this.filter.scheduleType = this.tempType
        this.showTypePopup = false
      } else if (operType === 'state') {
        this.filter.state = this.tempState
        this.showStatePopup = false
      } else if (operType === 'time') {
        this.filter.startTime = this.tempStartTime
        this.filter.endTime = this.tempEndTime
        this.showDatePopup = false
      }
      this.onLoad()
    },
    resetDate () {
      this.tempStartTime = ''
      this.tempEndTime = ''
    },

    onConfirmStartDate (val) {
      this.tempStartTime = moment(val).format('YYYY/MM/DD')
      this.showStartDatePicker = false
    },
    onConfirmEndDate (val) {
      this.tempEndTime = moment(val).format('YYYY/MM/DD')
      this.showEndDatePicker = false
    },

    // --- Data Loading ---
    onLoad () {
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })
      arsScheduleListPageApi(this.filter).then(res => {
        Toast.clear()
        res.data.list.forEach(subItem => {
          subItem.newScheduleTime = formatScheduleTime(subItem.scheduleTime)
          subItem.detailListTotal = subItem.detailList.length
          subItem.detailList = subItem.detailList.filter((detItem, detIndex) => {
            if (detIndex < 3) {
              return detItem
            }
          })
        })
        this.scheduleList = res.data.list
      })
    },
    navigate (params) {
      const currentTimeLoc =
        JSON.parse(window.localStorage.getItem('currentTimeLoc')) || {}

      if (!currentTimeLoc.lat || !currentTimeLoc.lng) {
        Toast(this.$t('tips.locationNotFound'))
        return
      }

      // 根据经纬度获取位置
      Toast.loading({
        message: this.$t('shared.loading'),
        forbidClick: true,
        duration: 0
      })

      // eslint-disable-next-line no-undef
      new google.maps.Geocoder().geocode(
        {
          // eslint-disable-next-line no-undef
          location: new google.maps.LatLng(
            currentTimeLoc.lat,
            currentTimeLoc.lng
          )
        },
        function geoResults (results, status) {
          Toast.clear()
          // eslint-disable-next-line no-undef
          if (status === google.maps.GeocoderStatus.OK) {
            window.location.href = `https://www.google.com/maps/dir/?api=1&dir_action=navigate&origin=${
              results[0].formatted_address
            }&destination=${params.address}`
          } else {
            // eslint-disable-next-line no-undef
            Toast('Google Map Error: ' + status)
          }
        }
      )
    }
  }
}
</script>

<style lang="less" scoped>
.schedule-page {
  background-color: #f7f8fa;
  min-height: 100vh;

  .filter-bar {
    display: flex;
    align-items: center;
    height: 36px;
    background: #fff;
    padding: 0 16px;
    border-bottom: 1px solid #eee;
    .filter-item {
      display: flex;
      align-items: center;
      margin-right: 20px;
      font-size: 14px;
      cursor: pointer;
      color: #333;

      .filter-arrow {
        font-size: 10px;
        margin-left: 4px;
        transform: rotate(90deg);
        color: #333;
      }

      &.active {
        color: #307bff; // Active color
        font-weight: 500;
        .filter-arrow {
          color: #307bff;
        }
      }

      &.date-item {
        margin-left: auto; // Push to right
        margin-right: 0;

        .calendar-icon {
          margin-right: 4px;
          font-size: 16px;
        }
        .date-text {
          font-size: 12px;
        }
      }
    }
  }

  .schedule-list {
    padding: 0;
  }

  .schedule-card {
    background: #fff;
    padding: 10px;
    border-bottom: 1px solid #eee;

    .card-top {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .time-text {
        font-size: 14px;
        font-weight: bold;
        margin-right: 10px;
      }

      .type-tag {
        display: inline-block;
        padding: 2px 8px;
        font-size: 12px;
        color: #307bff;
        background: #ecf5ff;
        border: 1px solid #307bff;
        line-height: 15px;
      }
    }

    .card-bottom {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      .store-icon {
        width: 16px;
        height: 16px;
        margin-right: 8px;
      }

      .store-name {
        flex: 1;
        font-size: 14px;
        color: #333;
        white-space: nowrap;
        overflow: hidden;
        text-overflow: ellipsis;
        margin-right: 12px;
      }

      .nav-icon {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
  }

  .filter-popup-content {
    padding: 16px;
    background: #fff;
    min-height: 200px;
    display: flex;
    flex-direction: column;

    .filter-title {
      font-size: 16px;
      font-weight: bold;
      margin-bottom: 20px;
      text-align: center;
      color: #333;
    }

    .filter-options {
      display: flex;
      flex-wrap: wrap;
      gap: 10px;
      margin-bottom: 30px;
      flex: 1;

      .filter-tag {
        height: 30px;
        line-height: 30px;
        padding: 0px 16px;
        background: #f5f6f8;
        border-radius: 4px;
        font-size: 12px;
        color: #333;
        cursor: pointer;
        min-width: 80px;
        text-align: center;

        &.active {
          background: #e6f1fc;
          color: #307bff;
          font-weight: 500;
        }
      }
    }

    .time-selector {
      display: flex;
      align-items: center;
      justify-content: space-between;
      margin-bottom: 30px;

      .time-input {
        flex: 1;
        height: 40px;
        background: #f5f6f8;
        border-radius: 4px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 14px;
        color: #333;

        .placeholder {
          color: #999;
        }
      }

      .separator {
        margin: 0 10px;
        color: #999;
      }
    }

    .filter-actions {
      display: flex;
      gap: 12px;

      .reset-btn {
        flex: 1;
        background: #f5f6f8;
        border: none;
        color: #333;
        border-radius: 6px;
      }

      .confirm-btn {
        flex: 1;
        border-radius: 6px;
      }
    }
  }
}
</style>
